import type { HTMLContent, ID, TEXT, UnixTime, URLString } from '~/interfaces/common';

export const ArticlePublishType = <const>{
  Personal: 'personal',
  Trivia: 'trivia',
};

export type ArticlePublishTypes = (typeof ArticlePublishType)[keyof typeof ArticlePublishType];

export interface Article {
  publish_type: ArticlePublishTypes;
  article_id: ID;
  title: TEXT;
  body: HTMLContent;
  image: URLString;
  publish_date: UnixTime;
  is_new: boolean;
}
